import React from 'react';

/**
 * Environment indicator (ARC-62).
 *
 * The partner/staging deploy and the member site are visually identical builds.
 * They differ only in which Firestore database they write to — REACT_APP_FIRESTORE_DB
 * selects a named database (see src/authentication/firebase-config.js). This chip
 * makes that difference visible so a test build is never mistaken for the live site.
 *
 * With the variable unset or empty (the member production build) this renders
 * nothing at all — no wrapper, no layout shift, zero visual change.
 *
 * It is fixed to the top of the viewport and `pointer-events-none`, so it never
 * intercepts a click meant for the app underneath.
 */
const EnvironmentBanner = () => {
  const dbName = process.env.REACT_APP_FIRESTORE_DB;
  if (!dbName) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[9999] pointer-events-none flex justify-center"
      data-testid="environment-banner"
    >
      <span
        role="status"
        className="inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide rounded-b-arc-sm px-3 py-1 text-arc-warn bg-arc-warn-soft ring-1 ring-arc-line backdrop-blur-sm"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true" />
        TEST ENVIRONMENT — {dbName} data
      </span>
    </div>
  );
};

export default EnvironmentBanner;
